import { userSlice } from "@/redux/User";
import { axiosGet } from "@/services/axiosService";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

export default function useGetCredits(fallbackCreditId?: string) {
  const dispatch = useDispatch();
  const reduxCreditId = useSelector((state: any) => state.user.creditId);
  const creditId = reduxCreditId || fallbackCreditId;

  const query = useQuery({
    queryKey: ["getCredits", creditId],
    enabled: !!creditId,
    queryFn: async () => {
      const response = await axiosGet(`/users/getCredits`);
      return {
        creditUsed: response.data.creditUsed,
        creditLimit: response.data.creditLimit,
      };
    },
    staleTime: 30_000,
  });

  useEffect(() => {
    if (query.data?.creditUsed !== undefined) {
      dispatch(userSlice.actions.setCreditUsed(query.data.creditUsed));
    }
  }, [query.data?.creditUsed, dispatch]);

  return query;
}
